'use client';

import { getFormattedValue } from '@wolfejs/core/utils/getFormattedValue';
import { Divider } from '@wolfejs/ui/Divider/Divider';
import type { UIThemableComponent } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';

export type DetailsListViewProps<T extends Object> = UIThemableComponent & {
  data: T;
  labels: {
    [key: string]: string;
  };
  schema?: Record<string, string>;
  divider?: boolean;
};

export const DetailsListView = <T extends Object>({
  data,
  labels,
  schema,
  classNames,
  divider = true,
}: DetailsListViewProps<T>) => {
  const dataPropertyArray = Object.entries(labels);
  let isZeroDiscount = false;
  if ('discount' in data) {
    isZeroDiscount = data.discount === 0;
  }
  return (
    <div className={classNames?.container}>
      {dataPropertyArray.map(
        ([key, value], index) =>
          data?.[key as keyof T] !== undefined && (
            <div key={key}>
              <div className={cn('flex flex-1 justify-between')}>
                <div className={cn('flex-1 text-base font-semibold', classNames?.label)}>{value}</div>
                <div className={cn('text-subheading text-base', classNames?.value)}>
                  {getFormattedValue(key, data?.[key as keyof T] as string, schema)}
                </div>
              </div>

              {dataPropertyArray.length - 1 !== index && divider && <Divider />}
            </div>
          )
      )}
    </div>
  );
};
